import script from "./ProductDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetail.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=d844c26e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d844c26e"]])

export default __exports__